import { render } from "./VUEAppContentGraficiVerticali.vue?vue&type=template&id=728f0020"
import script from "./VUEAppContentGraficiVerticali.vue?vue&type=script&lang=js"
export * from "./VUEAppContentGraficiVerticali.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__